module.exports = __webpack_public_path__ + "img/4.8728b2e6.png";